// extracted by mini-css-extract-plugin
export default {"wrapper":"XIt2uR1","dropdown":"BDgx2b2","sharedAmountWrapper":"MS2VTB3","sharedAmountTooltip":"w8IHygo","sharedText":"okPkUGf"};